export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS"